define('drops/calendarMonthView/calendarMonthView',[
    'jquery',
    'luxon',
    'globalize',
    'lq/drop',
    'lq/constants',
    'drops/calendar/calendarParameter',
    'drops/calendar/daysofmonthcalendar'
], function ($, luxon, globalize, Drop, constants, calendarParameter, DaysOfMonthCalendar) {
    'use strict';

    const { DateTime } = luxon;

    var defaults = {
        data: {
            dataSource: null,
            dateOutput: null,
            tooltipOutput: null,
            colorOutput: null,
            fontColorOutput: null,
            isUnavailableOutput: null,
            calendarStartParameter: 'CalendarMonthStart',
            calendarEndParameter: 'CalendarMonthEnd',
            titleFormat: 'MMMM yyyy',
            showWeekdayHeaders: false,
            weekdayHeadersFormat: 'ddd',
            eventing: {
                clicked: {}
            }
        }
    };

    function CalendarMonthView(options) {
        Drop.call(this, $('<div/>'), defaults, options);
    };

    Drop.extend(CalendarMonthView, Drop);

    CalendarMonthView.typeName = 'CalendarMonthView';

    CalendarMonthView.prototype.applyPosition = $.noop;

    CalendarMonthView.prototype.loadCalendarData = function () {
        if (!this.data.dataSource)
            return;

        var dateOfRequestedData = this.getOpenDate();

        var self = this;
        this.piping.queryDispatcher.backgroundDispatch(
            this.data.dataSource,
            function (response) {
                if (dateOfRequestedData.equals(self.getOpenDate()))
                    self.showColors(response.results);
            });
    };

    CalendarMonthView.prototype.setSelectedDate = function (date) {
        this.calendar.setSelectedDate(date);
    };

    CalendarMonthView.prototype.init = $.noop;

    CalendarMonthView.prototype.clearSelectedDate = function () {
        this.calendar.clearSelectedDate();
    };

    CalendarMonthView.prototype.getSelectedDate = function () {
        return this.calendar.getSelectedDate();
    };

    CalendarMonthView.prototype.render = function () {
        this.registerForDataSource();
        this.prepareUi();
        this.open(DateTime.now());
    };

    CalendarMonthView.prototype.prepareUi = function () {
        this.calendar = new DaysOfMonthCalendar({
            standalone: true,
            titleFormat: this.data.titleFormat,
            showWeekdayHeaders: this.data.showWeekdayHeaders,
            weekdayHeadersFormat: this.data.weekdayHeadersFormat,
            languageISOCode: this.piping.parameters.getValue('CurrentLanguageISOCode')
        });

        var self = this;
        this.calendar.withOnNavigated(function () {
            var parameters = self.piping.parameters;
            var startOfCurrentMonth = calendarParameter.convert(self.getOpenDate().startOf('month'));
            var endOfCurrentMonth = calendarParameter.convert(self.getOpenDate().endOf('month'));
            parameters.locals.setValue(self.data.calendarStartParameter, startOfCurrentMonth);
            parameters.locals.setValue(self.data.calendarEndParameter, endOfCurrentMonth);

            self.loadCalendarData();
            self.triggerEventIfEnabled('navigated', startOfCurrentMonth);
        });

        if (this.data.eventing.clicked.enabled) {
            this.calendar.withOnClicked(function (date) {
                var arg = globalize.format(date.toJSDate(), constants.licquidDateFormat);
                self.triggerEventIfEnabled('clicked', arg);
            });
        }

        this.$element
            .addClass('calendar-view month-view')
            .append(this.calendar.$element);
    };

    CalendarMonthView.prototype.registerForDataSource = function () {
        if (this.data.dataSource) {
            var self = this;
            this.piping.datasources.registerDatasourceListener(this.data.dataSource, function (data, _isUpdate) {
                self.calendar.rerender();
                self.showColors(data.results);
            });
        }
    };

    CalendarMonthView.prototype.open = function (date) {
        this.calendar.open(date);

        var parameters = this.piping.parameters;
        parameters.locals.setValue(this.data.calendarStartParameter, calendarParameter.convert(this.getOpenDate().startOf('month')));
        parameters.locals.setValue(this.data.calendarEndParameter, calendarParameter.convert(this.getOpenDate().endOf('month')));
    };

    CalendarMonthView.prototype.getOpenDate = function () {
        return this.calendar.getOpenDate();
    };

    CalendarMonthView.prototype.showColors = function (results) {
        var self = this;
        _.each(results, function (row) {
            var date = new Date(row[self.data.dateOutput]);
            var backgroundColor = row[self.data.colorOutput];
            var fontColor = row[self.data.fontColorOutput];
            var tooltip = row[self.data.tooltipOutput];
            var isUnavailable = row[self.data.isUnavailableOutput];
            self.calendar.decorateDate(date, backgroundColor, fontColor, tooltip, isUnavailable);
        });
    };

    CalendarMonthView.prototype.previous = function () {
        this.open(this.getOpenDate().minus({ months: 1 }));
        this.loadCalendarData();
        this.triggerNavigatedEvent();
    };

    CalendarMonthView.prototype.next = function () {
        this.open(this.getOpenDate().plus({ months: 1 }));
        this.loadCalendarData();
        this.triggerNavigatedEvent();
    };

    CalendarMonthView.prototype.triggerNavigatedEvent = function () {
        this.triggerEventIfEnabled('navigated', this.getOpenDate().startOf('month'));
    };

    return CalendarMonthView;
});
